var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3062_6151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.99927 2.66675V0.666748H3.3326V2.66675H5.3326V4.00008H3.3326V6.00008H1.99927V4.00008H-0.000732422V2.66675H1.99927ZM3.99927 6.66675V4.66675H5.99927V2.66675H10.6659L11.8859 4.00008H13.9993C14.7326 4.00008 15.3326 4.60008 15.3326 5.33342V13.3334C15.3326 14.0667 14.7326 14.6667 13.9993 14.6667H3.3326C2.59927 14.6667 1.99927 14.0667 1.99927 13.3334V6.66675H3.99927ZM8.66593 12.6667C10.5059 12.6667 11.9993 11.1734 11.9993 9.33342C11.9993 7.49341 10.5059 6.00008 8.66593 6.00008C6.82593 6.00008 5.3326 7.49341 5.3326 9.33342C5.3326 11.1734 6.82593 12.6667 8.66593 12.6667ZM6.5326 9.33342C6.5326 10.5134 7.48593 11.4667 8.66593 11.4667C9.84593 11.4667 10.7993 10.5134 10.7993 9.33342C10.7993 8.15341 9.84593 7.20008 8.66593 7.20008C7.48593 7.20008 6.5326 8.15341 6.5326 9.33342Z",
    fill: "#ABB9C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3062_6151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(-0.000732422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.616e347dee89dc92a7f2d75d7392843b.svg";
export { ForwardRef as ReactComponent };